
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'back': {
    width: 6,
    height: 11,
    viewBox: '0 0 6 11',
    data: '<path d="M5.92798 1.92799L2.26398 5.59999L5.92798 9.27199L4.79998 10.4L-2.14577e-05 5.59999L4.79998 0.799988L5.92798 1.92799Z" fill="#414162"/>'
  }
})
